import React, { useEffect, useState, useContext } from "react";
import Modal from "../Elements/Modal/Modal";
import { ALL_CURRENCIES } from "../../constants/currencies";
import { AuthContext } from "../../context/AuthContext";
import MainButton from "../Elements/MainButton/MainButton";
import SecondButton from "../Elements/SecondButton/SecondButton";
import ErrorMessage from "../Elements/ErrorMessage/ErrorMessage";
import SuccessMessage from "../Elements/SuccessMessage/SuccessMessage";

import WalletService from "../../services/WalletService";

import "./ProfileModals.css";

const WalletEditModal = ({ isOpen, onClose, wallet, onUpdated }) => {
  // Wallet currency state
  const [currency, setCurrency] = useState("");
  const { setWalletCurrency } = useContext(AuthContext);
  const [saving, setSaving] = useState(false);

  // UI feedback
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Initialize form when modal opens
  useEffect(() => {
    if (isOpen && wallet) {
      setCurrency(wallet.currency || "EUR");
      setError("");
      setSuccess("");
    }
  }, [isOpen, wallet]);

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setError("");
    setSuccess("");

    try {
      setSaving(true);

      const updatedWallet = await WalletService.changeWalletCurrency(wallet.id, currency);

      setWalletCurrency(currency);

      if (onUpdated) await onUpdated(currency);
      setSuccess("Wallet currency updated successfully.");
    } catch (err) {
      setError(err.message || "Failed to update wallet");
    } finally {
      setSaving(false);
    }
  };

  if (!isOpen || !wallet) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={saving ? () => {} : onClose}
      title="Edit wallet"
      actions={
        <>
          <SecondButton onClick={onClose} disabled={saving}>
            Cancel
          </SecondButton>
          <MainButton onClick={handleSubmit} disabled={saving}>
            {saving ? "Saving..." : "Save Changes"}
          </MainButton>
        </>
      }
    >
      <form onSubmit={handleSubmit} className="profile-modal-form">
        {/* Wallet currency select */}
        <label>
          Wallet currency
          <div className="profile-wallet-edit-select-wrapper">
            <select
              name="currency"
              value={currency}
              onChange={(e) => setCurrency(e.target.value)}
              disabled={saving}
              className="profile-wallet-edit-select"
            >
              {ALL_CURRENCIES.map(({ id, name }) => (
                <option key={id} value={id}>
                  {id} — {name}
                </option>
              ))}
            </select>
          </div>
        </label>

        {/* Error message */}
        {error && (
          <div className="profile-modal-error-wrapper">
            <ErrorMessage message={error} onClose={() => setError("")} />
          </div>
        )}

        {/* Success message */}
        {success && (
          <div className="profile-modal-success-wrapper">
            <SuccessMessage message={success} onClose={() => setSuccess("")} />
          </div>
        )}
      </form>
    </Modal>
  );
};

export default WalletEditModal;
